import { AppBox } from "../../../../commons/components";
import { User } from "../../../../commons/models/user";
import { toTitleCase } from "../../../../commons/utilities/string-utils";

interface UserActiveProps {
  user: User;
}
export default function UserActive({ user }: UserActiveProps) {
  return (
    <AppBox displayBlock>
      Once you make the user <strong>“{toTitleCase(user.fullName)}”</strong>{" "}
      active, the user will be able to log into the application.
    </AppBox>
  );
}
